import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DateTimeConvertService } from "src/app/services/CommonService/DateTimeConvert.service";
import { AppComponent } from "src/app/app.component";
import { tConsultHeadModelWithPatientInfo } from "src/app/models/tConsultHeadModel";
import {
  tBillPayModelWithItemCateInfo,
  BillPay_ItemType,
} from "src/app/models/tBillPayModel";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import {
  Input,
  Component,
  OnInit,
  Inject,
  LOCALE_ID,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { BillPay_PaymentMethod_Class } from "src/app/models/tPaymentModel";
import { SelectionModel } from "@angular/cdk/collections";
import { DatePipe, formatCurrency } from "@angular/common";
import { AppCurrencyPipeModule } from "src/app/services/CommonService/custom.currency.pipe";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";
import { AppSettings } from "src/app/shared/AppSettings";
import { json } from "express";
import { tShopService } from "src/app/services/tShop.service";
import { tEmployeeService } from "src/app/services/tEmployee.service";
import { tItemCateService } from "src/app/services/tItemCate.service";
import { tItemCateModel } from "src/app/models/tItemCateModel";
import { isNullOrUndefined, isUndefined } from "util";
import { forEach } from "@angular/router/src/utils/collection";
import { setDOM } from "@angular/platform-browser/src/dom/dom_adapter";
@Component({
  selector: "app-billpay-receipt-cert",
  templateUrl: "./billpay-receipt-cert.component.html",
  styleUrls: ["./billpay-receipt-cert.component.css"],
})
export class BillpayReceiptCertComponent implements OnInit {
  // picFullPath = 'assets/img/doc_logo2.png';

  // picFullPath = window.location.origin + '/assets/img/print/doc_logo.png';
  // @ViewChild("autoClick") autoClick: ElementRef;
  picFullPath = `${AppSettings.shopAdapter.imagePath}/favicon.png`;

  TAG = "BillpayReceiptCertComponent";

  isHiddenShop1Info = true;
  isHiddenShop2Info = true;
  shopAddressEng1 = "";
  shopAddressEng2 = "";
  shopAddressEng3 = "";
  shopAddress1 = "";
  shopAddress2 = "";
  shopAddress3 = "";
  shopPhone = "";
  shopEmail = "";
  shopNameTC = "";

  public display_patientID: string;
  public display_ECname: string;
  public display_ECno: string;
  public display_CTno: string;
  // shopFax='';

  @Input()
  selectedtConsultHeadModelWithPatientInfo: tConsultHeadModelWithPatientInfo;
  @Input() dataList_Item: tBillPayModelWithItemCateInfo[];
  @Input() dataList_Payment: tBillPayModelWithItemCateInfo[];

  @Input() isCheckBoxSelectedAll: boolean;
  @Input() selectedModel: SelectionModel<tBillPayModelWithItemCateInfo>;

  // @Input() billingNumber: string;

  public display_patientName: string;
  public display_date: Date;
  public display_diagonsis: string;
  // tslint:disable-next-line:max-line-length
  public display_line =
    "---------------------------------------------------------------------------------------------------------------------------------";
  public display_itemNameList: string;
  public display_itemPriceList: string;
  public display_itemSubtotal: string;

  public display_paymentList: string;
  public display_paymentPriceList: string;
  public display_totalPaidAmount: string;
  totalPaidAmount_Number = 0;

  public extraRemark: string;

  itemCateMaster: tItemCateModel[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private dateTimeConvertService: DateTimeConvertService,
    private log: LoggerService,
    private datepipe: DatePipe,
    private tShopService: tShopService,
    private tEmployeeService: tEmployeeService,
    private tItemCateService: tItemCateService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit() {
    this.getShopInfo(NavigationComponent.selectedShopID.toString());
    this.initItemCateMaster();
  }

  ngAfterViewInit() {
    //let inputElement: HTMLElement = this.autoClick.nativeElement as HTMLElement;
    //setTimeout(() => {
      //inputElement.click();
      //this.activeModal.close('Close click');
      // And any other code that should run only after 5s
    //}, 2000);
  }

  printReceipt_paymentClass: Array<BillPay_PaymentMethod_Class> = [];

  initItemCateMaster() {
    this.tItemCateService.getAllData().subscribe(
      (data) => {
        this.itemCateMaster = data;
        this.setConsultInfo(); //eg. set Date , Consult No. , Doctor Name ...

        //印單 is print all items?
        this.isCheckBoxSelectedAll
          ? this.SetupReceiptString()
          : this.SetupPrintNonFullReciptString();
      },
      (err) => console.error(err)
    );
  }

  //eg. set Date , Consult No. , Doctor Name ...
  setConsultInfo() {
    const info = this.selectedtConsultHeadModelWithPatientInfo;

    this.display_patientName = `${info.patientChiName} ${info.patientSurname} ${info.patientFirstName}`;
    this.display_patientID = info.patientID;
    this.display_ECname = info.clthTherapistName;
    this.display_CTno = info.clthConsultNumber;
    this.display_date = info.clthArrivalDateTime;
    this.display_diagonsis = info.clthDiagonsis;

    if (info.clthTherapistID) {
      this.tEmployeeService
        .getDataById(
          NavigationComponent.selectedShopID,
          info.clthTherapistID.toString()
        )
        .subscribe((therapisdata) => {
          this.display_ECname = therapisdata.employeeChiName;
          this.display_ECno = therapisdata.drRegNo;
        });
    }
  }

  SetupReceiptString() {
    this.log.i(this.TAG, "do SetupReceiptString");

    //this.setConsultInfo();

    this.display_itemNameList = "";
    this.display_itemPriceList = "";
    this.display_itemSubtotal = "";

    let itemSubTotal = 0;
    var isChangeAccount = false;
    var isChangeAccountPay = false;
    //console.table(this.dataList_Item);
    for (let i = 0; i < this.dataList_Item.length; i++) {
      const item = this.dataList_Item[i];

      //display item name
      this.display_itemNameList += `${i + 1}.${this.getItemNameDisplay(item)}`;

      //packdis
      if (this.dataList_Item[i].bpPackDis) {
        var bpPackDis = parseFloat(this.dataList_Item[i].bpPackDis);
        //   this.log.i(this.TAG,"bpPackDis= "+this.dataList_Item[i].bpPackDis +" , this.dataList_Item[i].bpArAmount *bpPackDis = "+this.dataList_Item[i].bpArAmount *bpPackDis);

        var itemDisplayPrice = this.dataList_Item[i].bpArAmount;

        /*
        if(NavigationComponent.billpayReceiptCert_isItemAmountAfterDiscount){
          itemDisplayPrice = (this.dataList_Item[i].bpArAmount * bpPackDis)
        }*/

        // this.display_itemPriceList += '$' + (this.dataList_Item[i].bpArAmount * bpPackDis).toFixed(1);
        // itemSubTotal += (this.dataList_Item[i].bpArAmount * bpPackDis)

        // this.display_itemPriceList += formatCurrency(Number(itemDisplayPrice.toFixed(1)),this.locale,'HKD') ;
        // this.display_itemPriceList += formatCurrency(
        //   Number(this.dataList_Item[i].bpArAmount.toFixed(1)),
        //   "en-US",
        //   "$",
        //   "",
        //   "1.1-1"
        // );

        this.display_itemPriceList += this.getPrice1Decimal(
          this.dataList_Item[i].bpArAmount
        );

        itemSubTotal += itemDisplayPrice;
      } else {
        //this.display_itemPriceList += '$' + (this.dataList_Item[i].bpArAmount).toFixed(1);
        //this.display_itemPriceList += formatCurrency(Number(this.dataList_Item[i].bpArAmount.toFixed(1)),"en-US",'$', '','1.1-1');
        this.display_itemPriceList += this.getPrice1Decimal(
          this.dataList_Item[i].bpArAmount
        );
        itemSubTotal += this.dataList_Item[i].bpArAmount;
      }

      // add next line
      if (i + 1 < this.dataList_Item.length) {
        this.display_itemNameList += "\n";
        this.display_itemPriceList += "\n";
      }

      //check is it changeAccount
      isChangeAccount = !isNullOrUndefined(this.dataList_Item[i].bpChangeID);
    }

    for (let i = 0; i < this.dataList_Payment.length; i++) {
      if (this.dataList_Payment[i].bpPaymentNumber != null) {
        isChangeAccount = false;
      }
    }
    this.display_itemSubtotal = "$" + itemSubTotal.toFixed(1);

    // -----------------payment display
    this.display_paymentList = "";
    this.display_totalPaidAmount = "";

    //Ignore void payment
    //: tBillPayModelWithItemCateInfo[];
    let dataList_IgnoreVoidPayment: Array<tBillPayModelWithItemCateInfo> = [];
    for (let i = 0; i < this.dataList_Payment.length; i++) {
      this.log.i(
        this.TAG,
        "dataList_IgnoreVoidPayment bpItemType = " +
          this.dataList_Payment[i].bpItemType +
          " , " +
          (this.dataList_Payment[i].bpItemType !== "Payment")
      );

      if (
        this.dataList_Payment[i].bpItemType !== "Payment" &&
        this.dataList_Payment[i].bpItemType.includes("Void")
      ) {
        dataList_IgnoreVoidPayment = [];
      } else {
        dataList_IgnoreVoidPayment.push(this.dataList_Payment[i]);
      }
    }

    // const printReceipt_paymentClass: Array<BillPay_PaymentMethod_Class> = [];
    this.printReceipt_paymentClass = [];
    this.log.i(
      this.TAG,
      "dataList_IgnoreVoidPayment length = " + dataList_IgnoreVoidPayment.length
    );

    //new
    for (let i = 0; i < dataList_IgnoreVoidPayment.length; i++) {
      // group payment Method
      if (this.printReceipt_paymentClass.length === 0) {
        if (
          dataList_IgnoreVoidPayment[i].bpPaymentMethodID === "Package" &&
          dataList_IgnoreVoidPayment[i].bpPackDis != null &&
          dataList_IgnoreVoidPayment[i].bpPackDis != undefined
        ) {
          //check shopID
          //paymentMethod With package
          var paymentPackagePrice = dataList_IgnoreVoidPayment[i].bpArAmount;

          /*   if(NavigationComponent.billpayReceiptCert_isPackageAmountAfterDiscount){
            paymentPackagePrice = (dataList_IgnoreVoidPayment[i].bpArAmount * parseFloat(dataList_IgnoreVoidPayment[i].bpPackDis));
          }*/

          this.log.i(
            this.TAG,
            "NavigationComponent.billpayReceiptCert_isPackageAmountAfterDiscount = " +
              NavigationComponent.billpayReceiptCert_isPackageAmountAfterDiscount +
              " , paymentPackagePrice = " +
              paymentPackagePrice
          );
          this.printReceipt_paymentClass.push(
            new BillPay_PaymentMethod_Class(
              dataList_IgnoreVoidPayment[i].bpPaymentMethodID,
              dataList_IgnoreVoidPayment[i].bpPaymentMethodName,
              paymentPackagePrice,
              dataList_IgnoreVoidPayment[i].bpItemType,
              dataList_IgnoreVoidPayment[i].bpPackDesc,
              dataList_IgnoreVoidPayment[i].bpPackDis,
              dataList_IgnoreVoidPayment[i].bpPackPatientID,
              dataList_IgnoreVoidPayment[i].specialPaymentType
            )
          );
        } else {
          //paymentMethod Without package
          const element = dataList_IgnoreVoidPayment[i];
          let pMethod = new BillPay_PaymentMethod_Class(
            element.bpPaymentMethodID,
            element.bpPaymentMethodName,
            element.bpArAmount,
            element.bpItemType,
            element.bpPackDesc,
            element.bpPackDis,
            element.bpPackPatientID,
            element.specialPaymentType
          );

          if (element.specialPaymentType == 2) {
            pMethod.paymentDesc = `${pMethod.paymentDesc}\n${element.ehVoucher}`;
          } else {
            pMethod.paymentDesc = pMethod.paymentDesc;
          }

          this.printReceipt_paymentClass.push(pMethod);
        }
      } else {
        for (let p = 0; p < this.printReceipt_paymentClass.length; p++) {
          // if same payment Method

          if (
            this.printReceipt_paymentClass[p].paymentID ===
            dataList_IgnoreVoidPayment[i].bpPaymentMethodID
          ) {
            if (
              dataList_IgnoreVoidPayment[i].bpPaymentMethodID === "Package" &&
              dataList_IgnoreVoidPayment[i].bpPackDis
            ) {
              this.printReceipt_paymentClass[p].paymentAmount +=
                dataList_IgnoreVoidPayment[i].bpArAmount *
                parseFloat(dataList_IgnoreVoidPayment[i].bpPackDis);
            } else {
              this.printReceipt_paymentClass[p].paymentAmount +=
                dataList_IgnoreVoidPayment[i].bpArAmount;
            }

            this.log.i(
              this.TAG,
              "same payment ID :" +
                dataList_IgnoreVoidPayment[i].bpPaymentMethodID +
                " ,new paymentAmount = " +
                this.printReceipt_paymentClass[p].paymentAmount
            );
            break;
          } else if (p + 1 < this.printReceipt_paymentClass.length === false) {
            // if not same payment method

            const element = dataList_IgnoreVoidPayment[i];
            let pMethod = new BillPay_PaymentMethod_Class(
              element.bpPaymentMethodID,
              element.bpPaymentMethodName,
              element.bpArAmount,
              element.bpItemType,
              element.bpPackDesc,
              element.bpPackDis,
              element.bpPackPatientID,
              element.specialPaymentType
            );

            if (element.specialPaymentType == 2) {
              pMethod.paymentDesc = `${pMethod.paymentDesc}\n${element.ehVoucher}`;
            } else {
              pMethod.paymentDesc = pMethod.paymentDesc;
            }

            this.printReceipt_paymentClass.push(pMethod);

            console.info(
              "printReceipt_paymentClass = ",
              this.printReceipt_paymentClass
            );

            break;
          }
        }
      }
    }

    // loop paymentlist

    // group the payment line and show the price
    let totalPaidAmount = 0;
    this.display_paymentPriceList = "";
    console.table(this.printReceipt_paymentClass);

    let index = 0;
    for (var p of this.printReceipt_paymentClass) {
      if (p.paymentAmount != 0 && p.bpItemType == BillPay_ItemType.PAYMENT) {
        this.display_paymentList +=
          p.paymentID === "Package" ? "其他" : p.paymentDesc;
      }

      this.display_paymentPriceList += "$" + (-1 * p.paymentAmount).toFixed(1);

      totalPaidAmount += p.paymentAmount;

      if (index + 1 < this.printReceipt_paymentClass.length) {
        this.display_paymentList += "\n";
        this.display_paymentPriceList += "\n";
      }
      index++;
    }

    this.display_totalPaidAmount = "$" + (-1 * totalPaidAmount).toFixed(1);
    this.totalPaidAmount_Number = Number((-1 * totalPaidAmount).toFixed(1));

    this.extraRemark = isChangeAccount ? "掛帳" : "";

    // ==========end payment display
    this.log.i(this.TAG, "display_itemNameList = " + this.display_itemNameList);
  }

  getItemNameDisplay(data: tBillPayModelWithItemCateInfo) {
    const name = data.bpPrintName ? data.bpPrintName : data.bpItemDesc;

    // Add Item Qty Display
    const cateID = this.itemCateMaster.find(
      (c) => c.itemCateID == data.itemCateID && c.isStock === "Y"
    );

    return cateID ? `${name} x ${data.bpQty}` : name;
  }

  SetupPrintNonFullReciptString() {
    this.log.i(this.TAG, "do SetupPrintNonFullReciptString");

    //this.setConsultInfo();

    this.display_itemNameList = "";
    this.display_itemPriceList = "";
    this.display_itemSubtotal = "";

    let itemSubTotal = 0;

    const selectedData: tBillPayModelWithItemCateInfo[] =
      this.selectedModel.selected;

    //Set Items detail display
    let index_data = 0;
    for (let data of selectedData) {
      //display item name
      this.display_itemNameList += `${index_data + 1}.${this.getItemNameDisplay(
        data
      )}`;

      //package discount
      let itemPrice = data.bpPackDis
        ? data.bpArAmount * parseFloat(data.bpPackDis)
        : data.bpArAmount;
      this.display_itemPriceList += "$" + itemPrice.toFixed(1);

      itemSubTotal += itemPrice;

      //add next line symbol
      if (index_data + 1 < selectedData.length) {
        this.display_itemNameList += "\n";
        this.display_itemPriceList += "\n";
      }

      index_data++;
    }

    this.display_itemSubtotal = "$" + itemSubTotal.toFixed(1);

    // Set Payment display

    this.display_paymentList = "";
    this.display_totalPaidAmount = "";

    this.printReceipt_paymentClass = [];

    //Ignore void payment
    //: tBillPayModelWithItemCateInfo[];
    let dataList_IgnoreVoidPayment: Array<tBillPayModelWithItemCateInfo> = [];
    for (let i = 0; i < this.dataList_Payment.length; i++) {
      this.log.i(
        this.TAG,
        "dataList_IgnoreVoidPayment bpItemType = " +
          this.dataList_Payment[i].bpItemType +
          " , " +
          (this.dataList_Payment[i].bpItemType !== "Payment")
      );

      if (
        this.dataList_Payment[i].bpItemType !== "Payment" &&
        this.dataList_Payment[i].bpItemType.includes("Void")
      ) {
        dataList_IgnoreVoidPayment = [];
      } else {
        dataList_IgnoreVoidPayment.push(this.dataList_Payment[i]);
      }
    }

    if (dataList_IgnoreVoidPayment.length > 0) {
      var itemPrice = itemSubTotal * -1;

      this.printReceipt_paymentClass.push(
        new BillPay_PaymentMethod_Class(
          dataList_IgnoreVoidPayment[0].bpPaymentMethodID,
          dataList_IgnoreVoidPayment[0].bpPaymentMethodName,
          itemPrice,
          dataList_IgnoreVoidPayment[0].bpItemType,
          dataList_IgnoreVoidPayment[0].bpPackDesc,
          dataList_IgnoreVoidPayment[0].bpPackDis,
          dataList_IgnoreVoidPayment[0].bpPackPatientID,
          dataList_IgnoreVoidPayment[0].specialPaymentType
        )
      );
    }
    this.log.i(
      this.TAG,
      "printReceipt_paymentClass = " +
        this.printReceipt_paymentClass.length +
        " , itemPrice = " +
        itemPrice
    );

    // loop paymentlist
    let totalPaidAmount = 0;
    this.display_paymentPriceList = "";
    for (let pp = 0; pp < this.printReceipt_paymentClass.length; pp++) {
      this.log.i(
        this.TAG,
        "dprintReceipt_paymentClass[pp].paymentDesc = " +
          this.printReceipt_paymentClass[pp].paymentDesc +
          " , printReceipt_paymentClass[pp].bpItemType = " +
          this.printReceipt_paymentClass[pp].bpItemType +
          " , printReceipt_paymentClass[pp].paymentAmount = " +
          this.printReceipt_paymentClass[pp].paymentAmount
      );

      // if no equal 0 , (with void)
      if (this.printReceipt_paymentClass[pp].paymentAmount !== 0) {
        if (
          this.printReceipt_paymentClass[pp].bpItemType ==
          BillPay_ItemType.PAYMENT
        ) {
          if (this.printReceipt_paymentClass[pp].paymentID === "Package") {
            this.display_paymentList += "其他";
          } else {
            this.display_paymentList +=
              this.printReceipt_paymentClass[pp].paymentDesc;
          }

          this.display_paymentPriceList +=
            "$" +
            (-1 * this.printReceipt_paymentClass[pp].paymentAmount).toFixed(1);
          totalPaidAmount += this.printReceipt_paymentClass[pp].paymentAmount;

          if (pp + 1 < this.printReceipt_paymentClass.length) {
            this.display_paymentList += "\n";
            this.display_paymentPriceList += "\n";
          }
        }
      }
    }

    this.display_totalPaidAmount = "$" + (-1 * totalPaidAmount).toFixed(1);
    this.totalPaidAmount_Number = Number((-1 * totalPaidAmount).toFixed(1));

    // ==========end payment display

    this.log.i(this.TAG, "display_itemNameList = " + this.display_itemNameList);
  }

  getPrice1Decimal(price: number) {
    return formatCurrency(Number(price.toFixed(1)), "en-US", "$", "", "1.1-1");
  }

  cancel() {
    // this.log.i(this.TAG, "do cancel");
    this.activeModal.close("Close click");
  }

  formatDate(date: Date) {
    const newDate = isUndefined(date) ? new Date(2023, 1, 1) : new Date(date);

    return this.datepipe.transform(newDate, "yyyy-MM-dd");
    // return this.dateTimeConvertService.ConvertCurrentDay(newDate);
  }

  getShopInfo(shopID: string) {
    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        this.shopAddressEng1 = res.shopAddressEng1;
        this.shopAddressEng2 = res.shopAddressEng2;
        this.shopAddressEng3 = res.shopAddressEng3;
        this.shopPhone = res.shopPhone;
        this.shopAddress1 = res.shopAddress1;
        this.shopAddress2 = res.shopAddress2;
        this.shopAddress3 = res.shopAddress3;
        this.shopEmail = res.shopEmail;
        this.shopNameTC = res.shopName;
        // this.shopFax=res.shopFax;
        // this.shopList = res;
        // this.shopName = this.shopList[0].shopName.toString();
        // console.log('shopList = ' + JSON.stringify(res));
        // console.log('shopList = ' + this.shopList[0].shopName.toString());
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
